var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkateboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.1,122.1V91.3c0-1.4-0.6-2.7-1.5-3.6l-13-13h18.3l20.3,20.3c2,2,5.3,2,7.3,0c2-2,2-5.3,0-7.3L74.7,65.8 c-1-1-2.3-1.5-3.6-1.5H30.6c0,3.2,1.3,6.1,3.4,8.2l20.9,20.9v28.7c0,2.8,2.3,5.1,5.1,5.1C62.8,127.3,65.1,124.9,65.1,122.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.6,
    cy: 23.1,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.1,50.4c-1-1-2.3-1.5-3.6-1.5H91L56.5,14.3c-0.9-0.9-2.2-1.5-3.6-1.5H32.3c-2.8,0-5.1,2.3-5.1,5.1s2.3,5.1,5.1,5.1 h18.4l7.9,7.9L30.6,59.1h32.7L75,47.4l10.2,10.2c1,1,2.3,1.5,3.6,1.5h20.6c1.3,0,2.6-0.5,3.6-1.5C115.1,55.6,115.1,52.4,113.1,50.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8,128.6c-1.4,0-2.6,1.2-2.6,2.6c0,1.4,1.2,2.6,2.6,2.6c1.4,0,2.6-1.2,2.6-2.6C79.4,129.8,78.3,128.6,76.8,128.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.8,101.6c-1.4,0-2.6,1.2-2.6,2.6c0,1.4,1.2,2.6,2.6,2.6c1.4,0,2.6-1.2,2.6-2.6C106.4,102.8,105.3,101.6,103.8,101.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9,97.9l-28.3,28.3c-3.1,3.1-7.3,4.9-11.7,4.9v2.7c5.1,0,10-2,13.6-5.6l28.3-28.3c3.6-3.6,5.6-8.5,5.6-13.6h-2.7 C103.7,90.6,102,94.8,98.9,97.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkateboard);
export default __webpack_public_path__ + "static/media/skateboard.8f272633a85d0c5de2b1174ea2bee55c.svg";
export { ForwardRef as ReactComponent };